import { Loader2 } from "lucide-react";

// Lightweight content-area loader shown while a lazy route chunk resolves. Kept inside the app
// shell so the sidebar and header stay visible during navigation (premium perceived performance).
export default function RouteFallback() {
  return (
    <div className="flex min-h-[50vh] w-full items-center justify-center" data-testid="route-loading">
      <Loader2 className="h-6 w-6 animate-spin text-[#0F766E]" />
    </div>
  );
}
